import { render, staticRenderFns } from "./AsRemoteAccesses.vue?vue&type=template&id=b5eb2518&scoped=true&"
import script from "./AsRemoteAccesses.vue?vue&type=script&lang=js&"
export * from "./AsRemoteAccesses.vue?vue&type=script&lang=js&"
import style0 from "./AsRemoteAccesses.vue?vue&type=style&index=0&id=b5eb2518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eb2518",
  null
  
)

export default component.exports